import { render, staticRenderFns } from "./DetailEven.vue?vue&type=template&id=20656dc3&"
import script from "./DetailEven.vue?vue&type=script&lang=js&"
export * from "./DetailEven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports